function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M0.29 0.16L10.605 0.16 10.605 8.229 0.29 8.229z"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__c",
  d: "M6.247.489l.03-.008-.314.066c-2.15.438-3.191.535-5.106.25C.67.792.405.761.061.71c.583.854 1.122 1.738 1.6 2.649.148.07.294.139.44.212 1.429.711 2.596 1.412 3.669 2.071l.644.4c1.111.693 2.068 1.294 3.122 1.605.435.128.844.2 1.25.224-.048-.129-.103-.257-.155-.386-.1-.25-.202-.499-.31-.745-.044-.102-.09-.203-.136-.305-.106-.24-.214-.48-.328-.716-.053-.112-.11-.223-.165-.333-.11-.224-.221-.447-.338-.668-.064-.125-.136-.249-.203-.373-.112-.203-.223-.406-.34-.605-.082-.141-.17-.28-.255-.418-.109-.179-.219-.359-.332-.534-.104-.16-.214-.315-.321-.472-.105-.15-.205-.303-.313-.45-.135-.188-.28-.368-.424-.552-.085-.11-.169-.225-.258-.333-.15-.184-.308-.36-.465-.537-.07.016-.136.032-.196.044"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__f",
  d: "M3.285.34C1.802.862.716 1.203.043 1.36c.158.176.316.352.465.536.09.108.173.223.258.333.144.184.289.364.424.552.108.147.208.3.313.45.107.157.217.312.321.473.115.174.223.355.332.533.085.139.173.276.256.419.116.198.227.401.339.604.067.125.139.248.203.373.117.221.227.444.338.668.055.11.112.222.165.333.114.236.222.475.328.716.045.102.092.203.135.305.109.247.211.495.311.745l.083.195h.004c.024.063.05.127.073.191.051.003.102.009.153.01 1.57.043 2.82-.7 4.142-1.488.293-.176 1.182-.65 2.181-1.166C8.564 3.96 6.227 1.903 3.552.245L3.285.34"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__j",
  d: "M1.135 1.452C.268 2.434.12 3.83.775 4.845c.66 1.02 1.78 1.43 3.001 1.099.507-.14.927-.542 1.099-1.053.087-.257.176-.761-.187-1.23-.299-.387-.975-.601-1.395-.297-.098.07-.257.248-.167.42.035.07.105.114.181.114.02 0 .051-.012.104-.032l.07-.025c.386-.137.77.03.94.405.052.117.08.245.08.379 0 .27-.12.546-.4.704-.1.061-.218.111-.356.15-1.01.275-2.048-.095-2.58-.922-.582-.9-.269-2.093.322-2.757C2.507.648 4.269.765 5.405 1.46c1.178.722 2.122 2.224 1.236 4.282-.6 1.39-2.24 2.125-4.745 2.131-.115 0-.238-.004-.363-.01.504.337 1.002.681 1.496 1.037.015-.005.032-.01.047-.013l.245-.064c.6-.156 1.24-.332 1.846-.581C6.144 7.84 7 7.017 7.398 6.093c1.09-2.527-.41-4.51-1.608-5.168C5.15.576 4.392.357 3.637.357c-.908 0-1.812.315-2.502 1.095"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__k",
  d: "M.352.702C3.027 2.36 5.364 4.416 7.667 6.599l.11-.057c.676-.35 2.33-1.197 3.119-1.529.595-.25 1.21-.426 1.814-.587l.376-.098c-.494-.355-.992-.7-1.496-1.037-.07-.002-.14-.006-.21-.01-.143-.012-.29-.022-.44-.04C7.782 2.893 3.302 1.054 1.477.297L.352.702"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__d",
  x1: "86.38%",
  x2: "39.987%",
  y1: "-39.687%",
  y2: "55.402%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#91A5CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3E62AD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__g",
  x1: "10.333%",
  x2: "50%",
  y1: "5.907%",
  y2: "81.222%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F181B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E52F8A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__h",
  x1: "9.599%",
  x2: "50%",
  y1: "4.515%",
  y2: "81.222%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E46CA6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E52F8A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__l",
  x1: "2.275%",
  x2: "61.687%",
  y1: "34.692%",
  y2: "56.171%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7D984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F7B400"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F7B400",
  d: "M0 7.835c4.797-.694 9.211.843 12.454 2.458-.617-1.248-1.349-2.444-2.157-3.589C7.595 6.277 1.557 5.122 0 7.835",
  transform: "translate(3.6 15.6) translate(0 .008)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.6 15.6) translate(0 .008) translate(11.886 9.6)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3E62AD",
  d: "M10.26 7.066c-.05-.163-.104-.326-.157-.489-.042-.124-.084-.25-.128-.375-.05-.147-.1-.294-.152-.442l-.131-.36c-.068-.186-.136-.37-.206-.556-.023-.057-.049-.114-.071-.171-.406-.025-.816-.097-1.25-.225-1.054-.312-2.011-.912-3.122-1.605l-.645-.4C3.325 1.783 2.158 1.083.73.371.584.3.438.23.29.16c.094.177.19.354.279.534 1.482.736 2.72 1.491 3.64 2.055 1.147.705 2.136 1.37 3.18 1.801-.835.745-1.738 1.936-1.909 2.356-.043.062-.068.126-.068.19 0 .612 2.249 1.133 4.393 1.133.266 0 .533-.01.8-.023-.077-.272-.158-.544-.241-.815-.034-.11-.07-.217-.103-.325",
  mask: "url(#prefix__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3E62AD",
  d: "M16.478 6.947l.314-.066-.03.008c.06-.012.126-.028.196-.044-.092-.102-.176-.208-.268-.309-.002.002-.285.058-.285.058-2.164.44-3.139.523-4.997.244-.223 0-.609-.055-1.11-.134.096.134.183.271.277.407.344.05.609.082.796.085 1.915.286 2.957.19 5.107-.249",
  transform: "translate(3.6 15.6) translate(0 .008)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E52F8A",
  d: "M25.6 12.793c-1.322.788-2.571 1.532-4.141 1.488-.052 0-.103-.006-.154-.009.02.058.043.114.066.172.025.065.053.13.078.197l-.003-.002c.045.121.087.242.132.361.043.12.088.24.13.36.054.147.102.295.153.442l.128.375c.053.163.106.326.157.489.035.109.07.216.103.325.084.27.164.543.242.815 1.87-.109 3.594-.575 3.594-1.11 0-.064-.024-.128-.069-.19-.176-.435-1.13-1.692-1.998-2.436.601-.275 1.18-.619 1.77-.969.29-.172 1.231-.677 2.27-1.211-.09-.088-.186-.175-.277-.262-.999.517-1.887.99-2.181 1.165M20.2 5.826l.267-.096c-.13-.08-.256-.165-.387-.243-1.207.425-2.628.893-3.39 1.05.092.1.178.206.268.308.672-.156 1.758-.498 3.242-1.02",
  transform: "translate(3.6 15.6) translate(0 .008)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E62AD",
  d: "M36.132 1.067c-1.566-.858-3.71-.964-5.095.603-1.006 1.14-1.12 2.702-.393 3.827.731 1.13 1.995 1.633 3.397 1.251 1.218-.332 1.89-1.836 1.106-2.851-.421-.543-1.311-.788-1.893-.367-.275.2-.445.555-.276.877.096.189.287.308.5.308.112 0 .194-.043.295-.08.512-.181.742.607.32.84-.082.053-.182.089-.27.113-.888.241-1.747-.087-2.185-.768-.456-.708-.243-1.725.289-2.326.852-.962 2.41-.911 3.462-.268 1.05.64 1.888 1.984 1.092 3.829-.64 1.483-2.54 1.912-4.414 1.915-.305.002-.631-.02-.975-.057.205.132.408.272.612.407.126.006.248.01.363.01 2.505-.005 4.146-.741 4.745-2.13.886-2.06-.058-3.56-1.235-4.282-1.137-.696-2.9-.813-3.919.339-.59.664-.904 1.857-.322 2.758.533.826 1.57 1.196 2.58.92.138-.038.257-.088.357-.149.28-.158.4-.434.4-.704 0-.133-.028-.262-.081-.379-.169-.376-.554-.542-.94-.405l-.07.025c-.052.02-.083.032-.104.032-.075 0-.146-.043-.18-.113-.09-.173.069-.35.166-.42.42-.305 1.097-.092 1.396.295.362.47.273.974.186 1.232-.172.51-.592.913-1.099 1.051-1.221.332-2.341-.077-3-1.098-.655-1.015-.508-2.41.36-3.393C32.57.48 34.554.613 35.96 1.382c1.198.657 2.698 2.64 1.609 5.168-.399.924-1.254 1.747-2.231 2.149-.606.25-1.246.425-1.846.581l-.246.064-.047.013c.125.091.256.179.382.272.638-.168 1.276-.341 1.892-.597 1.029-.423 1.978-1.3 2.425-2.34 1.114-2.581-.298-4.822-1.767-5.625",
  transform: "translate(3.6 15.6) translate(0 .008)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B400",
  d: "M32.824 9.454c-.604.161-1.219.337-1.814.588-.787.332-2.442 1.178-3.118 1.529-.037.02-.074.037-.11.057.09.087.185.173.275.262 1.17-.604 2.462-1.25 3.093-1.516.788-.334 1.61-.532 2.432-.745-.127-.093-.257-.181-.382-.272-.126.031-.25.065-.376.097M21.591 5.326c1.826.756 6.305 2.595 9.463 2.943.151.018.297.028.44.04.07.005.14.008.21.011-.204-.135-.407-.275-.612-.407-3.043-.337-7.307-2.066-9.491-2.972-.39.142-.93.338-1.52.546.13.078.257.162.386.243l1.124-.404",
  transform: "translate(3.6 15.6) translate(0 .008)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.6 15.6) translate(10.514 6.408)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#prefix__d)",
  xlinkHref: "#prefix__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.247.489l.03-.008-.314.066c-2.15.438-3.191.535-5.106.25C.67.792.405.761.061.71c.583.854 1.122 1.738 1.6 2.649.148.07.294.139.44.212 1.429.711 2.596 1.412 3.669 2.071l.644.4c1.111.693 2.068 1.294 3.122 1.605.435.128.844.2 1.25.224-.048-.129-.103-.257-.155-.386-.1-.25-.202-.499-.31-.745-.044-.102-.09-.203-.136-.305-.106-.24-.214-.48-.328-.716-.053-.112-.11-.223-.165-.333-.11-.224-.221-.447-.338-.668-.064-.125-.136-.249-.203-.373-.112-.203-.223-.406-.34-.605-.082-.141-.17-.28-.255-.418-.109-.179-.219-.359-.332-.534-.104-.16-.214-.315-.321-.472-.105-.15-.205-.303-.313-.45-.135-.188-.28-.368-.424-.552-.085-.11-.169-.225-.258-.333-.15-.184-.308-.36-.465-.537-.07.016-.136.032-.196.044",
  mask: "url(#prefix__e)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.6 15.6) translate(16.914 5.493)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__i",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__f"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#prefix__g)",
  xlinkHref: "#prefix__f"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__h)",
  d: "M3.285.34C1.802.862.716 1.203.043 1.36c.158.176.316.352.465.536.09.108.173.223.258.333.144.184.289.364.424.552.108.147.208.3.313.45.107.157.217.312.321.473.115.174.223.355.332.533.085.139.173.276.256.419.116.198.227.401.339.604.067.125.139.248.203.373.117.221.227.444.338.668.055.11.112.222.165.333.114.236.222.475.328.716.045.102.092.203.135.305.109.247.211.495.311.745l.083.195h.004c.024.063.05.127.073.191.051.003.102.009.153.01 1.57.043 2.82-.7 4.142-1.488.293-.176 1.182-.65 2.181-1.166C8.564 3.96 6.227 1.903 3.552.245L3.285.34",
  mask: "url(#prefix__i)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.6 15.6) translate(30.171 .465)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3E62AD",
  xlinkHref: "#prefix__j"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B400",
  d: "M32.824 9.462l.376-.098c-.494-.355-.992-.699-1.495-1.036-.071-.003-.14-.006-.211-.011.438.386.882.769 1.33 1.145",
  transform: "translate(3.6 15.6)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.6 15.6) translate(20.114 5.036)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__m",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__k"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#prefix__l)",
  xlinkHref: "#prefix__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.352.702C3.027 2.36 5.364 4.416 7.667 6.599l.11-.057c.676-.35 2.33-1.197 3.119-1.529.595-.25 1.21-.426 1.814-.587l.376-.098c-.494-.355-.992-.7-1.496-1.037-.07-.002-.14-.006-.21-.01-.143-.012-.29-.022-.44-.04C7.782 2.893 3.302 1.054 1.477.297L.352.702",
  mask: "url(#prefix__m)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B400",
  d: "M21.6 2.03c-.506 0-.916.411-.916.918 0 1 .723 1.808.917 2 .193-.192.917-1 .917-2 0-.507-.411-.917-.917-.917",
  transform: "translate(3.6 15.6)"
}));

function SvgAladinOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAladinOn);
export default __webpack_public_path__ + "static/media/aladin-on.2f28b355.svg";
export { ForwardRef as ReactComponent };